export default {
    media: {
        select: {
            video: "Seleccionar un video (MP4, MOV, WebM)",
            audio: "Seleccionar un audio (MP3, M4A, AAC, WAV, OGG)",
        },
        noFile: {
            video: "Ningún video",
            audio: "Ningún audio",
        },
        remove: "Quitar",
        validation: {
            badFormat: {
                video: "El video debe estar en formato MP4, MOV o WebM.",
                audio: "El audio debe estar en formato MP3, M4A, AAC, WAV u OGG.",
            },
            maxFileSize: {
                video: "El video no debe superar los 500 MB.",
                audio: "El audio no debe superar los 100 MB.",
            },
        },
    },
    image: {
        title: "Imágenes",
        name: "Imagen",
        uploadTitle: "Subir imágenes",
        upload: "Subir",
        uploadSuccess: "Imágenes subidas con éxito",
        uploadError: "Error al subir",
        drop: "Haz clic o arrastra una imagen",
        dropOrClick: "Haz clic o arrastra una nueva imagen",
        myImages: "Las imágenes del curso",
        sharedImage: "Imágenes compartidas",
        noImage: "No se ha subido ninguna imagen",
        noImageSelected: "No hay imagen seleccionada",
        pickerImage: "Imágenes",
        pickerUpload: "Subir",
        selectImage: "Seleccionar una imagen",
        replaceImage: "Reemplazar imagen",
        currentImage: "Imagen actual",
        newImage: "Nueva imagen",
        remove: "Quitar",
        validation: {
            badFormat: "El archivo debe estar en formato JPG, PNG o SVG.",
            maxFileSize: "La imagen no debe superar los 5MB.",
            badImageSize:
                "La imagen debe tener una dimensión de 500x500px o 625x500px.",
            imageNotReadable: "No se puede leer la imagen.",
            tooSmallImage: "La imagen es demasiado pequeña.",
            conversionError: "Error al convertir la imagen.",
            loadError: "Error al cargar la imagen.",
        },
    },
    topicCategory: {
        title: "Categorías",
        field: {
            name: "Nombre",
            rank: "Posición",
        },
    },
    trainingVersion: {
        title: "Versiones del curso",
        field: {
            rank: "Posición",
            title: "Título",
            description: "Descripción",
            isAvailable: "Disponible",
            topicIds: "Temas",
            topicIdsPlaceholder:
                "Busca y selecciona los temas incluidos en esta versión.",
            relatedTopicIds: "Temas relacionados",
            relatedTopicIdsPlaceholder:
                "Busca y selecciona temas relacionados.",
        },
    },
    testimony: {
        title: "Testimonios",
        status: {
            draft: "Borrador",
            available: "Disponible",
            unavailable: "No disponible",
        },
        field: {
            title: "Título",
            subtitle: "Subtítulo",
            description: "Descripción",
            status: "Estado",
            image: "Imagen",
            videoLink: "Enlace de video",
            text: "Texto",
            tags: "Etiquetas",
            keywords: "Palabras clave de búsqueda",
            comments: "Comentarios",
            rank: "Posición",
        },
    },
    topic: {
        title: "Temas",
        new: "Nuevo tema",
        status: {
            draft: "Borrador",
            available: "Disponible",
            unavailable: "No disponible",
        },
        level: {
            all: "Todos",
            beginner: "Principiante",
            intermediate: "Intermedio",
            advanced: "Avanzado",
        },
        help:
            "La información se muestra en la aplicación de la siguiente manera:",
        field: {
            title: "Título",
            description: "Descripción",
            image: "Imagen",
            level: "Nivel",
            status: "Estado",
            tags: "Etiquetas",
            rank: "Posición",
            category: "Categoría",
            keywords: "Palabras clave de búsqueda",
            introduction: "Introducción",
            synthesis: "Síntesis",
            conclusion: "Conclusión",
            goals: "Objetivos",
            relatedTopics: "Temas relacionados",
            relatedTopicsPlaceholder:
                "Busque y marque los temas a vincular con este.",
            comments: "Comentarios",
            categoryPlaceholder: "Selecciona una categoría",
            titlePlaceholder: "Los Fundamentos del Matrimonio",
            descriptionPlaceholder:
                "Comprender las bases de un matrimonio sólido",
            levelPlaceholder: "Todos",
            statusPlaceholder: "Disponible",
            tagsPlaceholder: "Matrimonio, Familia, Relación",
            keywordsPlaceholder: "matrimonio, familia, relación",
            introductionPlaceholder: "Introducción",
            synthesisPlaceholder: "Síntesis",
            conclusionPlaceholder: "Conclusión",
            goalsPlaceholder: "Objetivos",
            commentsPlaceholder: "",
        },
    },
    topicPart: {
        title: "Partes",
        new: "Nueva parte",
        addSynthesisPart: "Parte de síntesis",
        synthesisPartAlreadyExists:
            "Solo se permite una parte de síntesis por tema",
        defaultSynthesis: {
            title: "Noche en pareja",
            description:
                "Tomamos un tiempo juntos para intercambiar y hacer balance del tema abordado",
            text: "Ahora puedo tomarme unos momentos para releer mis respuestas, seleccionar las que deseo compartir y luego responder a las preguntas de síntesis",
            question1: "¿Qué tengo ganas de compartir?",
            question2: "¿Cuál es para mí el punto más importante de este tema?",
        },
        field: {
            answerTogether: "Respuestas juntas",
            isSynthesisPart: "Parte de síntesis",
            title: "Título",
            description: "Descripción",
            image: "Imagen",
            duration: "Duración (min)",
            videoLink: "Enlace de video",
            videoFile: "Archivo de video",
            audioFile: "Archivo de audio",
            contentText: "Texto",
            additionalText: "Texto adicional (Ver más)",
            comments: "Comentarios",
            rank: "Posición",
            titlePlaceholder: "Las Bases del Matrimonio Cristiano",
            descriptionPlaceholder: "Presentación de los pilares fundamentales",
            durationPlaceholder: "30",
            videoLinkPlaceholder: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
            contentTextPlaceholder: "Ingresa el texto principal",
            additionalTextPlaceholder: "Ingresa el texto adicional",
            commentsPlaceholder: "",
        },
        validation: {
            videoSourceConflict:
                "Elija un enlace de video o un archivo de video, no ambos.",
        },
    },
    topicPartQuestion: {
        title: "Preguntas",
        answerType: {
            text: "Texto",
            multipleChoice: "Opción múltiple",
            singleChoice: "Opción única",
            yesNo: "Sí - No",
            yesNoUnknown: "Sí - No - No sé",
        },
        field: {
            text: "Pregunta",
            textPlaceholder:
                "¿Cuáles son los pilares de un matrimonio cristiano?",
            answerType: "Tipo de respuesta",
            type: "Tipo",
            answers: "Respuestas",
            rank: "Posición",
            comments: "Comentarios",
        },
    },
};
